/* eslint-disable no-console */
// no console warning is disabled, as this function communicates with the user via console and we don't want to use default logger here
import { spawn } from 'child_process';

export function openInEditor(filePath: string) {
  const explicitEditor = process.env.EDITOR;
  const isWindows = process.platform === 'win32';

  let command: string;
  let args: string[];
  // On Windows, `spawn` needs the shell to resolve PATH extensions (e.g.
  // notepad.exe) when launching a user-configured editor by name.
  let useShell = false;
  // Bypass Node's argument quoting so the raw `start "" <path>` arguments are
  // passed verbatim to cmd.exe (see Windows branch below).
  let windowsVerbatimArguments = false;

  if (explicitEditor) {
    command = explicitEditor;
    useShell = isWindows;
    args = useShell ? [`"${filePath}"`] : [filePath];
  } else if (isWindows) {
    // No editor configured: open the log with its default associated app.
    // Invoke `start` via `cmd.exe /c` with `shell: false` so the path is not
    // re-parsed by an outer shell. The path is wrapped in double quotes (which
    // cmd.exe treats literally) to guard against spaces and special characters
    // such as `%`, `&`, `^`, and `!` that can appear in a Windows temp path.
    command = 'cmd.exe';
    // The empty "" is the window-title argument `start` expects first.
    args = ['/c', 'start', '""', `"${filePath}"`];
    windowsVerbatimArguments = true;
  } else {
    command = 'vi';
    args = [filePath];
  }

  console.log(`Opening ${filePath} in ${command}...`);

  const editorProcess = spawn(command, args, {
    shell: useShell,
    windowsVerbatimArguments,
    stdio: 'inherit',
  });

  editorProcess.on('error', (error) => {
    console.error('Failed to start editor:', error.message);
    process.exit(1);
  });

  editorProcess.on('close', (code) => {
    if (code !== 0) {
      console.error(`Editor exited with code ${code}`);
      process.exit(code ?? 1);
    }
  });
}

/**
 * Opens `filePath` in `$EDITOR` when stdout is a TTY, otherwise prints the
 * path. Avoids dumping the editor's control sequences into a pipe/capture.
 */
export function openInEditorOrPrint(filePath: string) {
  if (!process.stdout.isTTY) {
    console.log(filePath);
    return;
  }
  openInEditor(filePath);
}
